<!--  -->
<template>
    <div class='Conference_index'>
        <div class="Conference_index_box">
            <div class="meeting_box">
                <div v-for="(item,index) in list" :key="index" style="margin:0 40px;" @click="ondetails(item)"> 
                    <div class="meeting_box_img">
                        <img :src="item.photo" alt="">
                    </div>
                    <div class="meeting_box_title">
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/css/About_ISFAL.less"
    export default {
        name: 'Conference_index',
        data() {
            //这里存放数据
            return {
                list:[]
            }
        },
        components: {},

        //方法集合
        methods: {
            ondetails(item){
                console.log(item)
                this.$router.push('/Conference/details/'+item.code)
            },
            meetinglist() {
                var _this = this;
                _this.$api.meetinglist({
                    // keyword: _this.keywork
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        _this.list = res.data.list

                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
        },
        created() {

        },
        mounted() {
            this.meetinglist()
        }
    }
</script>
<style scoped>

</style>